var _style, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "SVG_Main_Logo",
  x: "0px",
  y: "0px",
  viewBox: "0 0 275.2 143.7",
  style: {
    enableBackground: "new 0 0 275.2 143.7"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0p{fill:#414042;}\r\n\t.st1p{fill:#121212;}\r\n\t.st2p{fill:#6C6D6D;}\r\n\t.st3p{fill:#6D6E71;}\r\n\t.st4p{fill:#58595B;}\r\n\t.st5p{fill:#1E1E1E;}\r\n\t.st6p{fill:#197F38;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0p",
  d: "M243.2,80.1c3.2,0.4,32-47.8,32-47.8l-71.1,15.2L220.3,61L243.2,80.1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0p",
  d: "M37.1,70.3C33.4,69.8,0,0,0,0l16.6,8.3L90.5,45L68.4,55.5L37.1,70.3z"
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "207,143.6 35,71.2 90.7,44.2 191,35.9 231.1,95.8 "
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "253.3,76.5 191,35.9 219.8,104.7 207,143.6 "
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1p",
  points: "90.5,110.2 34.9,71.2 206.3,143.6 "
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  className: "st2p",
  points: "106.4,75.8 154.2,87.5 170.5,69.3 "
})), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
  points: "34.9,71.2 106.4,75.8 127.5,96.8 "
})), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3p",
  points: "95.9,103.5 132.6,89.8 34.9,71.2 "
})), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
  points: "34.9,71.2 0,0 68.4,55.5 "
})), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
  className: "st4p",
  points: "196.9,119.6 219.8,104.7 187.1,95.6 "
})), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
  points: "219.8,104.7 253.3,76.5 191,35.9 "
})), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
  className: "st4p",
  points: "187.1,95.6 171.5,70.3 191,35.9 219.8,104.7 "
})), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0p",
  points: "187.1,95.6 219.8,104.7 191,35.9 170.5,69.3 "
})), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
  className: "st4p",
  points: "89.7,44.4 106.4,75.8 35,71.2 "
})), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
  className: "st5p",
  points: "187.1,95.6 170.5,69.3 152.7,87.2 "
})), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6p",
  points: "106.4,75.8 132.6,89.8 187.1,95.6 "
}, /*#__PURE__*/React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "fill",
  attributeType: "XML",
  calcMode: "linear",
  dur: "5s",
  fill: "remove",
  repeatCount: "indefinite",
  restart: "always",
  values: "#55BC78;#dbff05;#55BC78;#55BC78"
}))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6p",
  points: "252.9,76.6 243.8,89.7 233.2,94 "
}, /*#__PURE__*/React.createElement("animate", {
  accumulate: "none",
  additive: "replace",
  attributeName: "fill",
  attributeType: "XML",
  calcMode: "linear",
  dur: "5s",
  fill: "remove",
  repeatCount: "indefinite",
  restart: "always",
  values: "#55BC78;#dbff05;#55BC78;#55BC78"
}))), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0p",
  points: "211.8,110.5 206.3,143.6 95.9,103.5 133.4,89.7 "
})), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
  points: "132.6,89.8 212.9,110.6 187.1,95.6 "
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Logo.4ad289bb.svg";
export { ForwardRef as ReactComponent };